import { render, staticRenderFns } from "./SearchCustomerWidget.vue?vue&type=template&id=740e5711&"
import script from "./SearchCustomerWidget.vue?vue&type=script&lang=js&"
export * from "./SearchCustomerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports